import React, { useEffect, useState } from "react";

import { Modal } from "@king-ict/eupisi-ui/components";
import { Location } from "history";
import { useTranslation } from "react-i18next";
import { Prompt } from "react-router-dom";

import { useAppDispatch } from "../app/store";
import { resetIsEdited } from "../slices/applicationSlice";

interface Props {
  when?: boolean | undefined;
  navigate: (path: string) => void;
}

const RouteLeavingGuard = ({ when, navigate }: Props) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [lastLocation, setLastLocation] = useState<Location | null>(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const closeModal = () => {
    setModalVisible(false);
  };

  const handleBlockedNavigation = (nextLocation: Location): boolean => {
    if (!confirmedNavigation) {
      setModalVisible(true);
      setLastLocation(nextLocation);
      return false;
    }
    return true;
  };

  const handleConfirmNavigationClick = () => {
    setModalVisible(false);
    setConfirmedNavigation(true);
  };

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      // Navigate to the previous blocked location with your navigate function
      dispatch(resetIsEdited());
      setConfirmedNavigation(false);
      navigate(lastLocation.pathname);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmedNavigation]);

  return (
    <>
      <Prompt when={when} message={handleBlockedNavigation} />

      <Modal
        type={"confirm"}
        title={t("common.cancelModalTitle")}
        cancelText={t("common.no")}
        confirmText={t("common.yes")}
        open={modalVisible}
        onClose={closeModal}
        onConfirm={handleConfirmNavigationClick}
      >
        {t("common.cancelModalMessage")}
      </Modal>
    </>
  );
};
export default RouteLeavingGuard;
